import axios from 'axios';
import { CREATE_INVOICE, GET_INVOICES, GET_INVOICE, UPDATE_INVOICE, DELETE_INVOICE, INVOICE_ERROR} from '../ActionTypes/invoiceVActionTypes';

// Création d'une facture
export const addInvoice = (invoiceData) => async (dispatch) => {
  try {
    // S'assurer que les données sont correctement formatées
    const formattedData = {
      ...invoiceData,
      // S'assurer que tva est un nombre
      tva: parseFloat(invoiceData.tva) || 0,
      // Formater les items pour inclure le champ tva
      items: invoiceData.items.map(item => ({
        ...item,
        // Ajouter le champ tva manquant pour chaque item
        tva: parseFloat(item.tva) || 0,
        // S'assurer que tous les champs numériques sont bien des nombres
        quantity: parseFloat(item.quantity) || 0,
        price: parseFloat(item.price) || 0,
        tvaAmount: parseFloat(item.tvaAmount) || 0,
        total: parseFloat(item.total) || 0
      }))
    };

    console.log('Envoi des données au backend:', formattedData);

    const response = await axios.post('/api/InvoicesV/addInvoice', formattedData);

    console.log('Réponse reçue du backend:', response.data);

    dispatch({
      type: CREATE_INVOICE,
      payload: response.data.invoice,
    });

    console.log('Action CREATE_INVOICE dispatchée avec succès');
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement de la facture:', error.response ? error.response.data : error.message);

    dispatch({
      type: INVOICE_ERROR,
      payload: error.response?.data?.message || 'Une erreur s\'est produite',
    });
  }
};


// Récupérer toutes les factures
export const getInvoices = () => async (dispatch) => {
  try {
    const response = await axios.get('/api/InvoicesV/getInvoices');
    
    // Transformons les données pour générer le tableau voulu
    const transformedData = transformInvoices(response.data);

    dispatch({
      type: GET_INVOICES,
      payload: transformedData,
    });
  } catch (error) {
    dispatch({
      type: INVOICE_ERROR,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Fonction de transformation des données
const transformInvoices = (invoices) => {
  const stockData = {};

  invoices.forEach((invoice) => {
    invoice.items.forEach((item) => {
      const { family, ingredient, quantity, price } = item;

      // On vérifie si l'ingrédient existe déjà dans le stock
      if (!stockData[ingredient._id]) {
        stockData[ingredient._id] = {
          ingredientName: ingredient.name,
          family: family.name, // Assurez-vous que la famille a un attribut `name`
          totalQuantity: 0,
          totalPrice: 0,
          count: 0,
          quantityUnit: item.unit || '', // Nature de la quantité
          safetyStock: 0, // Vous pouvez l'ajouter ici ou ailleurs
        };
      }

      // Cumuler les quantités et les prix
      stockData[ingredient._id].totalQuantity += quantity;
      stockData[ingredient._id].totalPrice += quantity * price;
      stockData[ingredient._id].count += 1;
    });
  });

  // Calculer le prix moyen pour chaque ingrédient
  const result = Object.keys(stockData).map((ingredientId) => {
    const item = stockData[ingredientId];
    const averagePrice = item.totalPrice / item.totalQuantity;

    return {
      ...item,
      averagePrice,
    };
  });

  return result;
};

// Récupérer une facture spécifique par son ID
export const getInvoice = (id) => async (dispatch) => {
  try {
    const response = await axios.get(`/api/InvoicesV/getInvoice/${id}`);
    dispatch({
      type: GET_INVOICE,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: INVOICE_ERROR,
      payload: error.response?.data?.message || error.message
    });
  }
};

// Mettre à jour une facture
export const updateInvoice = (id, invoiceData) => async (dispatch) => {
  try {
    const response = await axios.put(`/api/InvoicesV/updateInvoice/${id}`, invoiceData);
    dispatch({
      type: UPDATE_INVOICE,
      payload: response.data.invoice
    });
  } catch (error) {
    dispatch({
      type: INVOICE_ERROR,
      payload: error.response?.data?.message || error.message
    });
  }
};

// Supprimer une facture
export const deleteInvoice = (id) => async (dispatch) => {
  try {
   await axios.delete(`/api/InvoicesV/deleteInvoice/${id}`);
    dispatch({
      type: DELETE_INVOICE,
      payload: id
    });
  } catch (error) {
    dispatch({
      type: INVOICE_ERROR,
      payload: error.response?.data?.message || error.message
    });
  }
};


